export default __webpack_public_path__ + "static/media/JSC.4facea9d.png";